import Http from "../services/Providers/Http";

const ENDPOINTS = {
  GET_PROJECTS: "/api/dash/getProjects",
  GET_NOTICES: "/api/dash/getNotices",
  GET_PASSIVE_PROJECTS: "/api/dash/getPassiveProjects",
  GET_ALL_PROJECTS: "/api/dash/getAllProjects",
  SAVE_PROJECT: "/api/dash/saveProject",
  GET_SUPER_ADMINS: "/api/dash/getSuperAdmins"
};

export default {
  getProjects: (payload, params) => {
    return Http.get(ENDPOINTS.GET_PROJECTS, params, null, payload);
  },
  getNotices: (payload, params) => {
    return Http.get(ENDPOINTS.GET_NOTICES, params, null, payload);
  },
  getPassiveProjects: (payload, params) => {
    return Http.get(ENDPOINTS.GET_PASSIVE_PROJECTS, params, null, payload);
  },
  getAllProjects: (payload, params) => {
    return Http.get(ENDPOINTS.GET_ALL_PROJECTS, params, null, payload);
  },
  getSuperAdmins: (payload, params) => {
    return Http.get(ENDPOINTS.GET_SUPER_ADMINS, params, null, payload);
  },
  saveProject: (body, payload, params) => {
    return Http.post(ENDPOINTS.SAVE_PROJECT, body, params, null, payload);
  },
}; 